import getSymbolFromCurrency from "currency-symbol-map";

interface CurrencyDisplayProps {
  currencyCode?: string;
  amount?: number;
}

const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({ currencyCode = '$', amount }) => {
  const symbol = getSymbolFromCurrency(currencyCode) || currencyCode;

  const formatAmount = (num: number | undefined): string => {
    if (num === undefined) return '';
    const roundedNum = Math.round(num * 100) / 100;
    return roundedNum.toLocaleString(undefined, {
      minimumFractionDigits: roundedNum % 1 ? 2 : 0,
      maximumFractionDigits: 2,
    });
  };
  return (
    <span>
      {symbol} {amount && amount >= 1000 ? `${formatAmount(amount / 1000)}K` : formatAmount(amount)}
    </span>
  );
};




export default CurrencyDisplay;
